import React from 'react'
import SignupContainer from 'modules/react/signup/SignupContainer'
import SignupModal from 'modules/react/signup/SingleClassOrGSK/SignupModal'

export default function SingleClassOrGSKSignup ({ course, nonce, restUrls, buttonText, modalRightContent }) {
  return (
    <SignupContainer course={course} nonce={nonce} restUrls={restUrls} buttonText={buttonText} modalRightContent={modalRightContent}>
      <SignupModal/>
    </SignupContainer>
  )
}